module.exports = __webpack_public_path__ + "static/media/icon.d35a6c49.png";